// Approved 2026-09-14 handover data — source of truth for service pages & enquiry form.
import approved from './approvedPackages.json';

export const CATEGORIES = approved.categories; // [{id, name}]
export const PACKAGES = approved.packages;
export const PACKAGE_NOTES = approved.notes || [];

// Canonical URL slug for each of the 16 categories (shared with the portfolio taxonomy).
export const CATEGORY_SLUGS = {
  1: 'wedding', 2: 'engagement', 3: 'birthday-debut', 4: 'anniversary',
  5: 'christening-baptism', 6: 'maternity', 7: 'newborn', 8: 'family',
  9: 'portrait-creative', 10: 'graduation-formal', 11: 'corporate-community',
  12: 'commercial-product-food', 13: 'automotive', 14: 'sports-fitness',
  15: 'concert-performance', 16: 'other',
};
export const categorySlug = (id) => CATEGORY_SLUGS[id] || '';

// Approved optional add-ons per service (from the handover copy). Amounts are agreed in
// writing and quoted separately — shown for transparency, not added to the estimate.
export const SERVICE_ADDONS = {
  Photography: [
    { name: 'Extra photography coverage', amount: '$200 / hour' },
    { name: 'Extra edited images (portrait, newborn, fitness)', amount: '$20 each or $150 for 10' },
    { name: 'Commercial extra image (same setup)', amount: '$35 each' },
    { name: 'Second photographer', amount: 'Custom quote' },
  ],
  Videography: [
    { name: 'Extra videography time', amount: '$250 / hour' },
    { name: 'Ceremony edit (up to 45 min)', amount: '$450' },
    { name: 'Speeches / performance edit (up to 30 min)', amount: '$350' },
    { name: 'Extra vertical reel (30–60 sec)', amount: '$150' },
    { name: 'Additional minor revision', amount: '$150 / round' },
    { name: 'Second operator or extra location', amount: 'Custom quote' },
  ],
};

export const categoryName = (id) => CATEGORIES.find((c) => c.id === id)?.name || '';

// Format a package price for display, honouring price_type (fixed | from | custom).
export const priceLabel = (pkg) => {
  if (pkg.price_type === 'custom' || pkg.price_aud == null) return 'Custom quote';
  const amt = `$${Number(pkg.price_aud).toLocaleString('en-AU')}`;
  return pkg.price_type === 'from' ? `from ${amt}` : amt;
};

export const hours = (mins) => {
  if (!mins) return '';
  const h = mins / 60;
  return Number.isInteger(h) ? `${h} hr${h === 1 ? '' : 's'}` : `${mins} min`;
};

export const packagesByService = (service) =>
  PACKAGES.filter((p) => p.service === service);

// Packages for a given service + category id, always followed by that service's custom option.
export const packagesFor = (service, categoryId) => {
  const list = PACKAGES.filter(
    (p) => p.service === service && (!categoryId || p.category_ids.includes(Number(categoryId)))
  );
  return list;
};

// Group a service's packages by the primary category name (for page display).
export const groupedByCategory = (service) => {
  const groups = [];
  CATEGORIES.forEach((cat) => {
    const items = PACKAGES.filter(
      (p) => p.service === service && p.category_ids.includes(cat.id)
    );
    if (items.length) groups.push({ category: cat.name, items });
  });
  return groups;
};

// Shared pricing & booking rules (from START_HERE handover). Displayed on service pages.
export const SHARED_RULES = [
  'All prices are in AUD and no GST is charged. Applicable travel and any additions are quoted separately.',
  'A signed agreement plus a 30% booking fee reserves your date; the balance is due 14 days before the event. Within 14 days of the date, full payment accompanies the signed agreement unless otherwise agreed. Quotes are valid for 14 days.',
  'Travel (one-way from Cranbourne): up to 30 km included; 31–50 km +$75; 51–75 km +$150; 76–100 km +$250 (subject to confirmation); over 100 km by custom quote. Tolls and parking at actual cost. A Sunday or public-holiday booking is +$100, once per booking.',
  'Extra time: photography $200/hour, videography $250/hour, Glam Booth $150/hour.',
  'Galleries: photos via Lightroom, booth via Snappic, video via private Google Drive. Access runs 60 days from each final delivery; +$25 per extra 30 days (agreed before expiry); file retrieval $75 if files remain.',
];
